define([
    "./monitoringInvoiceDeliveryEffectivenessOverviewModule",
    "./monitoringInvoiceDeliveryEffectivenessOverviewController"
], function () {
});